<div class="affichage-depart-arrivee">
	<div class="depart-trajet">
		<div class="heure-trajet">
			<div class="heure">{{ dateDepart() | date: 'HH\'h\'mm' }}</div>
		</div>
		<div class="lieu-trajet">
			{{ lieuDepart() }}
		</div>
		@if (lienGoogleMaps(adresseDepart()); as lien) {
			<a class="adresse-trajet adresse-lien"
			   [href]="lien"
			   target="_blank">
				{{ adresseDepart() }}
			</a>
		} @else {
			<div class="adresse-trajet">
				{{ adresseDepart() ?? ('GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.ADRESSE_VIDE' | translate) }}
			</div>
		}
	</div>
	<div class="divider"></div>
	<div class="arrivee-trajet">
		<div class="heure-trajet">
			<div class="heure">{{ dateArrivee() | date: 'HH\'h\'mm' }}</div>
		</div>
		<div class="lieu-trajet">
			{{ lieuArrivee() }}
		</div>
		@if (lienGoogleMaps(adresseArrivee()); as lien) {
			<a class="adresse-trajet adresse-lien"
			   [href]="lien"
			   target="_blank">
				{{ adresseArrivee() }}
			</a>
		} @else {
			<div class="adresse-trajet">
				{{ adresseArrivee() ?? ('GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.ADRESSE_VIDE' | translate) }}
			</div>
		}
	</div>
</div>
